import { View } from 'foundations-components/components/View';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { LazyImageProvider } from 'trellis-ecosystem';
import { CollectionSection } from '../../collections/components/CollectionSection';
import { SuggestedCollections } from '../../collections/components/SuggestedCollections';
import { APPS_SUGGESTED_COLLECTION_IDS } from '../../collections/constants/collections';
import { useCollectionApps } from '../../collections/hooks/useCollectionApps';
import { AllProductsSection } from '../../components/AllProductsSection';
import { SliderSection } from '../../components/SliderSection';
import { useGates } from '../../hooks/useGates';
import { SuggestedFilters } from '../../solutions/components/SuggestedFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ProductHomeSections({
  error,
  featuredCollectionId,
  loading,
  productType,
  remainingSections,
  sections
}) {
  const totalSectionsLength = sections.length + remainingSections.length + 2; // Total sections: sections + CollectionSection + remainingSections + AllProductsSection
  const {
    cards,
    collectionId,
    collectionSlug,
    description,
    hasValidCollectionData,
    queryType,
    title
  } = useCollectionApps(featuredCollectionId);
  const gates = useGates();
  if (loading) return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true
  });
  if (error) return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest"
  });
  return /*#__PURE__*/_jsx(LazyImageProvider, {
    children: /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "500",
      children: [sections === null || sections === void 0 ? void 0 : sections.map((section, index) => {
        var _section$contexts;
        return /*#__PURE__*/_jsx(SliderSection, {
          cards: section.cards,
          context: (_section$contexts = section.contexts) === null || _section$contexts === void 0 ? void 0 : _section$contexts[0],
          productType: productType,
          sectionIndex: index,
          sectionType: section.sectionType,
          title: section.title
        }, index);
      }), productType === 'AGENT' && hasValidCollectionData && /*#__PURE__*/_jsx(CollectionSection, {
        cards: cards,
        collectionId: collectionId,
        collectionSlug: collectionSlug,
        description: description,
        productType: productType,
        queryType: queryType,
        sectionCount: totalSectionsLength,
        sectionIndex: sections.length,
        title: title
      }), productType === 'APP' && /*#__PURE__*/_jsx(SuggestedCollections, {
        collectionIds: APPS_SUGGESTED_COLLECTION_IDS
      }), remainingSections === null || remainingSections === void 0 ? void 0 : remainingSections.map((section, index) => {
        var _section$contexts2;
        return /*#__PURE__*/_jsx(SliderSection, {
          cards: section.cards,
          context: (_section$contexts2 = section.contexts) === null || _section$contexts2 === void 0 ? void 0 : _section$contexts2[0],
          productType: productType,
          sectionIndex: sections.length + index + 1,
          sectionType: section.sectionType,
          title: section.title
        }, index);
      }), gates.solutionsSpringSpotlight && /*#__PURE__*/_jsx(SuggestedFilters, {}), /*#__PURE__*/_jsx(AllProductsSection, {
        productType: productType,
        sectionIndex: totalSectionsLength
      })]
    })
  });
}